import React from "react";
import ReactDom from "react-dom/client";
import { AdminIndex } from "./AdminIndex";
import { AdminDetail } from "./AdminDetail";
import { AdminPurchases } from "./AdminPurchases";

(window as any).loadAdminIndex = function (ele: any, props: {}) {
  ReactDom.createRoot(ele).render(<AdminIndex {...(props || {})} />);
};

(window as any).loadAdminDetail = function (ele: any, props: {}) {
  ReactDom.createRoot(ele).render(<AdminDetail {...(props || {})} />);
};

(window as any).loadAdminPurchases = function (
  ele: any,
  props?: { purchases: Array<any>; activations: Array<any> }
) {
  ReactDom.createRoot(ele).render(<AdminPurchases {...(props || {})} />);
};
